<template>
	<div>
		<app-layout>
			<template v-slot:header>
				<Header :title="$t('pos_return_days')" :isNewButton="checkPermission('posreturnday_store')" :isColumns="true"
					@new-button-click="createFormShow()"
					@filter-div-status="datatable.filterStatus = $event">
					<template v-slot:columns>
						<div class="mb-1" v-for="(column, key) in datatable.columns" :key="key">
							<b-form-checkbox :id="'checkbox-' + key" :name="'checkbox-' + key" :value="false"
								:unchecked-value="true" v-model="column.hidden" v-if="column.field != 'buttons'">
								{{ column.label }}
							</b-form-checkbox>
						</div>
					</template>
				</Header>
			</template>
			<template v-slot:header-mobile>
				<HeaderMobile :title="$t('pos_return_days')" :isNewButton="checkPermission('posreturnday_store')" :isColumns="true"
					@new-button-click="createFormShow()"
					@filter-div-status="datatable.filterStatus = $event">
					<template v-slot:columns>
						<div class="mb-1" v-for="(column, key) in datatable.columns" :key="key">
							<b-form-checkbox :id="'checkbox-' + key" :name="'checkbox-' + key" :value="false"
								:unchecked-value="true" v-model="column.hidden" v-if="column.field != 'buttons'">
								{{ column.label }}
							</b-form-checkbox>
						</div>
					</template>
				</HeaderMobile>
			</template>
			<datatable-filter v-show="datatable.filterStatus" @filter="filter" @filterClear="filterClear">
				<b-row>
					<!-- COURSE CODE -->
					<b-col sm="6" md="3">
                            <b-form-group :label="$t('bank')">
                                <bank-selectbox v-model="datatable.queryParams.filter.bank_id">
                                </bank-selectbox>
                            </b-form-group>
					</b-col>

					<!-- COURSE NAME -->
					<b-col sm="6" md="3">
                        <b-form-group :label="$t('start_date')">
                            <select-date
                                v-model="datatable.queryParams.filter.start_date"> </select-date>
                        </b-form-group>
					</b-col>

					<!-- COURSE TYPE -->
					<b-col sm="6" md="3">
                        <b-form-group :label="$t('end_date')">
                            <select-date
                                v-model="datatable.queryParams.filter.end_date"></select-date>
                        </b-form-group>
					</b-col>

					<!-- COURSE STATUS -->
					<b-col sm="6" md="3">
                        <b-form-group :label="$t('installment')">
                            <b-input
                                v-model="datatable.queryParams.filter.installment"
                                type="number"
                                max="12"
                                min="0"
                                class="text-center"
                            ></b-input>
                        </b-form-group>
					</b-col>

					<!--  FACULTY CODE -->
					<b-col sm="6" md="3">
                        <b-form-group :label="$t('number_of_days')">
                          <b-input
                              v-model="datatable.queryParams.filter.days"
                              type="number"
                              min="1"
                              class="text-center"
                          ></b-input>
                        </b-form-group>
					</b-col>

				</b-row>
			</datatable-filter>
			<datatable :isLoading.sync="datatable.isLoading" :columns="datatable.columns" :rows="datatable.rows"
				:total="datatable.total" :queryParams="datatable.queryParams" @on-page-change="onPageChange"
				@on-sort-change="onSortChange" @on-per-page-change="onPerPageChange" v-show="datatable.showTable">
			</datatable>
			<CommonModal ref="createFormModal" size="md" :onHideOnlyX="true" @bHideModalHeaderClose="formClear">
				<template v-slot:CommonModalTitle>
					{{ $t('new').toUpper() }}
				</template>
				<template v-slot:CommonModalContent>
					<create-form @createFormSuccess="createFormSuccess" v-if="formProcess == 'create'" />
				</template>
			</CommonModal>
			<CommonModal ref="updateFormModal" size="md" :onHideOnlyX="true" @bHideModalHeaderClose="formClear">
				<template v-slot:CommonModalTitle>
					{{ $t('edit').toUpper() }}
				</template>
				<template v-slot:CommonModalContent>
					<update-form :formId="formId" @updateFormSuccess="updateFormSuccess" v-if="formProcess == 'update'" />
				</template>
			</CommonModal>
		</app-layout>
	</div>
</template>
<script>
// Template
import AppLayout from "@/layouts/AppLayout"
import Header from "@/layouts/AppLayout/Header"
import HeaderMobile from "@/layouts/AppLayout/HeaderMobile"

// Components
import DatatableFilter from "@/components/datatable/DatatableFilter";
import Datatable from "@/components/datatable/Datatable";
import CommonModal from "@/components/elements/CommonModal";

// Pages
import CreateForm from "./Create.vue";
import UpdateForm from "./Update.vue";

// Services
import CourseService from "@/services/CourseService";

// Others
import qs from 'qs'
import PosReturnDaysServices from "@/services/PosReturnDaysServices";
import BankSelectbox from "@/components/interactive-fields/BankSelectbox.vue";
import DaysSelectbox from "@/components/interactive-fields/DaysSelectbox.vue";

export default {
	components: {
        DaysSelectbox,
        BankSelectbox,
		AppLayout,
		Header,
		HeaderMobile,
		DatatableFilter,
		Datatable,
		CommonModal,
		CreateForm,
		UpdateForm,
	},
	metaInfo() {
		return {
			title: this.$t('pos_return_days')
		}
	},
	data() {
		return {
			datatable: {
				isLoading: false,
				columns: [
					{
						label: '',
						field: 'buttons',
						html: true,
						sortable: false,
						tdClass: 'p-0 text-center w-40 align-middle',
						buttons: [
							{
								text: this.$t('edit'),
								class: 'ri-search-eye-line align-middle top-minus-1 mr-3 text-muted',
								permission: "posreturnday_update",
								callback: (row) => {
									this.updateFormShow(row.id)
								}
							},
							{
								text: this.$t('delete'),
								class: 'ri-delete-bin-7-line align-middle top-minus-1 mr-3 text-muted',
								permission: "posreturnday_delete",
								callback: (row) => {
									this.formDelete(row.id)
								}
							}
						]
					},
					{
						label: this.toUpperCase('id'),
						field: 'id',
						hidden: true,
					},
          {
            label: this.toUpperCase('bank'),
            field: 'bank_name',
            hidden: false,
          },
          {
            label: this.toUpperCase('installment'),
            field: 'installment',
            hidden: false,
          },
					{
						label: this.toUpperCase('number_of_days'),
						field: 'days',
						hidden: false,
					},
					{
						label: this.toUpperCase('start_date') + ' - ' + this.toUpperCase('end_date') ,
						field: 'start_date',
						hidden: false,
						formatFn: (value, row) => {
                            return this.toLocaleDate(row.start_date)  + ' / ' + this.toLocaleDate(row.end_date);
                        },
					},
				],
				rows: [],
				total: 0,
				filterStatus: true,
				showTable: false,
				queryParams: {
					filter: {},
					sort: '-id',
					page: 1,
					limit: 20
				}
			},
			formProcess: null,
			formId: null,
			form: {},
		}
	},
	created() {
		this.filterSet();
		this.formClear();
	},
	methods: {
		filterSet() {
			this.datatable.queryParams.filter = {
                bank_id:null,
                start_date:null,
                end_date:null,
                installment:null,
                days:null
			}
		},
		filterClear() {
			this.filterSet()
			this.getRows();
		},
		filter() {
			this.datatable.queryParams.page = 1;
			this.getRows();
		},
		onPageChange(params) {
			this.datatable.queryParams.page = params.currentPage;
			this.getRows();
		},
		onPerPageChange(params) {
			this.datatable.queryParams.limit = params.currentPerPage;
			this.datatable.queryParams.page = 1;
			this.getRows();
		},
		changeColumn(key) {
			this.datatable.columns[key].hidden = this.datatable.columns[key].hidden == true ? false : true;
		},
		onSortChange(params) {
			const sortType = params[0].type == 'desc' ? '-' : '';
			this.datatable.queryParams.sort = sortType + params[0].field
			this.getRows();
		},
		getRows() {
			this.datatable.showTable = true;
			this.datatable.isLoading = true;
			const config = {
				params: {
					...this.datatable.queryParams
				},
				paramsSerializer: (params) => qs.stringify(params, { encode: false })
			};
			return PosReturnDaysServices.getAll(config)
				.then((response) => {
					this.datatable.rows = response.data.data
					this.datatable.total = response.data.pagination.total
				})
				.finally(() => {
					this.datatable.isLoading = false;
				});
		},
		formClear() {
			this.formId = null
			this.formProcess = null
		},
        createFormShow() {
			this.formId = null
			this.formProcess = 'create'
			this.$refs.createFormModal.$refs.commonModal.show()
		},
		createFormSuccess() {
			this.$refs.createFormModal.$refs.commonModal.hide()
			this.getRows()
			this.formClear()
		},
        updateFormShow(id) {
			this.formId = id
			this.formProcess = 'update'
			this.$refs.updateFormModal.$refs.commonModal.show()
		},
		updateFormSuccess() {
			this.$refs.updateFormModal.$refs.commonModal.hide()
			this.getRows()
			this.formClear()
		},
		formDelete(id) {
           this.deleteModal(()=>{
               PosReturnDaysServices.del(id)
                   .then(response => {
                       this.$toast.success(this.$t('api.' + response.data.message));
                       this.getRows();
                       this.formClear();
                   })
                   .catch(error => {
                       this.$toast.error(this.$t('api.' + error.data.message));
                   });
            })
		},
		exportExcel() {
			const config = {
				params: {
					...this.datatable.queryParams
				},
				paramsSerializer: (params) => qs.stringify(params, { encode: false })
			};

			return CourseService.exportExcel(config)
				.then((response) => {
					this._downloadFile(response, 'courses.xlsx')
				})
				.catch(e => {
				});
		},
		importData() {
			this.formProcess = 'import'
			this.$refs.importFormModal.$refs.commonModal.show()
		},
		importFormSuccess() {
			this.formProcess = null;
			this.$refs.importFormModal.$refs.commonModal.hide()
		}
	}
}
</script>

